const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_4363_63616)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.8305 4.19923C12.8305 4.19923 12.8305 4.13282 12.8305 4C12.8305 3.86718 12.9172 3.76501 13.0907 3.69349H27.3074C25.8702 2.8046 24.9844 1.66539 24.6499 0.275862C24.6499 0.265645 24.6499 0.250319 24.6499 0.229885C24.6499 0.209451 24.6437 0.194125 24.6313 0.183908C24.6313 0.0613027 24.7366 0 24.9472 0H25.003C25.1145 0 25.1888 0.00510856 25.226 0.0153257C25.2631 0.0255428 25.3003 0.045977 25.3375 0.0766283C25.3746 0.10728 25.3932 0.153257 25.3932 0.214559C25.3932 0.275862 25.4118 0.357599 25.449 0.45977C25.4861 0.561941 25.5357 0.689655 25.5976 0.842912C25.8702 1.52746 26.3224 2.14049 26.9543 2.68199C27.5861 3.2235 28.3233 3.60664 29.1658 3.83142C29.2773 3.86207 29.333 3.91826 29.333 4C29.333 4.0613 29.302 4.10728 29.2401 4.13793C29.1781 4.16858 29.0295 4.21967 28.7941 4.29119C28.5587 4.36271 28.3233 4.45977 28.0879 4.58238C27.5799 4.84802 27.1401 5.15453 26.7684 5.50192C26.3967 5.8493 26.118 6.19157 25.9322 6.52874C25.7463 6.8659 25.6162 7.12133 25.5419 7.29502C25.4676 7.46871 25.418 7.62708 25.3932 7.77011C25.3684 7.87229 25.3375 7.93359 25.3003 7.95402C25.2631 7.97446 25.164 7.98978 25.003 8C24.7552 8 24.6313 7.94381 24.6313 7.83142C24.6313 7.7599 24.6623 7.63218 24.7242 7.44828C25.1207 6.16092 25.9817 5.11367 27.3074 4.30651H13.0907C12.9172 4.23499 12.8305 4.13282 12.8305 4V4.19923Z",
  fill: "#0C2846"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.33301 4.19949C1.33301 4.19949 1.33301 4.13307 1.33301 4.00025C1.33301 3.86743 1.43482 3.76526 1.63845 3.69374H14.3144C14.5326 3.77547 14.6417 3.87765 14.6417 4.00025C14.6417 4.12286 14.5326 4.22503 14.3144 4.30677H1.63845C1.43482 4.23525 1.33301 4.13307 1.33301 4.00025V4.19949Z",
  fill: "#0C2846"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.8305 4C12.8305 4.13282 12.8305 4.19923 12.8305 4.19923V4ZM12.8305 4C12.8305 3.86718 12.9172 3.76501 13.0907 3.69349H27.3074C25.8702 2.8046 24.9844 1.66539 24.6499 0.275862C24.6499 0.265645 24.6499 0.250319 24.6499 0.229885C24.6499 0.209451 24.6437 0.194125 24.6313 0.183908C24.6313 0.0613027 24.7366 0 24.9472 0H25.003C25.1145 0 25.1888 0.00510856 25.226 0.0153257C25.2631 0.0255428 25.3003 0.045977 25.3375 0.0766284C25.3746 0.10728 25.3932 0.153257 25.3932 0.214559C25.3932 0.275862 25.4118 0.357599 25.449 0.45977C25.4861 0.561941 25.5357 0.689655 25.5976 0.842912C25.8702 1.52746 26.3224 2.14049 26.9543 2.68199C27.5861 3.2235 28.3233 3.60664 29.1658 3.83142C29.2773 3.86207 29.333 3.91826 29.333 4C29.333 4.0613 29.302 4.10728 29.2401 4.13793C29.1781 4.16858 29.0295 4.21967 28.7941 4.29119C28.5587 4.36271 28.3233 4.45977 28.0879 4.58238C27.5799 4.84802 27.1401 5.15453 26.7684 5.50192C26.3968 5.8493 26.118 6.19157 25.9322 6.52874C25.7463 6.8659 25.6162 7.12133 25.5419 7.29502C25.4676 7.46871 25.418 7.62708 25.3932 7.77011C25.3684 7.87229 25.3375 7.93359 25.3003 7.95402C25.2631 7.97446 25.164 7.98978 25.003 8C24.7552 8 24.6313 7.94381 24.6313 7.83142C24.6313 7.7599 24.6623 7.63218 24.7242 7.44828C25.1207 6.16092 25.9817 5.11367 27.3074 4.30651H13.0907C12.9172 4.23499 12.8305 4.13282 12.8305 4ZM1.33301 4.00025C1.33301 4.13307 1.33301 4.19949 1.33301 4.19949V4.00025ZM1.33301 4.00025C1.33301 3.86743 1.43482 3.76526 1.63845 3.69374H14.3144C14.5326 3.77547 14.6417 3.87765 14.6417 4.00025C14.6417 4.12286 14.5326 4.22503 14.3144 4.30676H1.63845C1.43482 4.23525 1.33301 4.13307 1.33301 4.00025Z",
  stroke: "#0C2846",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 11,
  height: 17,
  transform: "matrix(1 0 0 -1 11 25)",
  stroke: "#0081CC"
}));

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4363_63616"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "white"
})));

const SvgEquationScripts6 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquationScripts6, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation-scripts-6.2bd4bd52.svg";
export { ForwardRef as ReactComponent };